import { render, staticRenderFns } from "./MaterialTemplateList.vue?vue&type=template&id=718996d8&scoped=true&"
import script from "./MaterialTemplateList.vue?vue&type=script&lang=ts&"
export * from "./MaterialTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialTemplateList.vue?vue&type=style&index=0&id=718996d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718996d8",
  null
  
)

export default component.exports